import { FormEvent } from 'react';
import classNames from 'classnames';

import { useTranslator } from '@picsart/rc/services/localization';
import { IconSearch } from '@picsart/design-system/foundation/icons/IconSearch';
import { IconCrossCircleOutline } from '@picsart/design-system/foundation/icons/IconCrossCircleOutline';
import { TextField } from '@picsart/design-system/components/TextField';

import useSearch from 'hooks/useSearch';
import ISearchInput from './types';
import useStyles from './styles';

// filter selector should be added permanently, not just in category page
function SearchInput({
  placeholder,
  containerClassName,
  isTemplatePage,
  size,
  filterType,
}: ISearchInput) {
  const classes = useStyles();
  const translate = useTranslator();

  const { status, query, handleChange, handleSubmit, searchIconRef, handleClear } = useSearch();

  return (
    <div className={classNames(classes.root, containerClassName)}>
      <form onSubmit={(e: FormEvent) => handleSubmit(e, filterType)} data-testid="search-form">
        <TextField
          className={isTemplatePage && classes.searchInputWithSelector}
          status={status}
          ref={searchIconRef}
          placeholder={translate(placeholder)}
          value={query}
          onChange={handleChange}
          iconClick={handleClear}
          startIcon={IconSearch}
          endIcon={query && IconCrossCircleOutline}
          size={size}
          autoCapitalize="none"
          enterKeyHint="search"
          autoComplete="off"
        />
      </form>
    </div>
  );
}

export default SearchInput;
